
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".8","clip-path":"url(#icon-bell_svg__clip0_4472_6556)","fill":"#9AA5BB"}},[_c('path',{attrs:{"d":"M22.697 11.632a1 1 0 01-1-1c0-2.805-1.092-5.44-3.075-7.425a.999.999 0 111.414-1.414 12.418 12.418 0 013.66 8.84 1 1 0 01-.999 1zM2.982 11.632a1 1 0 01-1-1c0-3.339 1.3-6.478 3.661-8.839a.999.999 0 111.414 1.414 10.432 10.432 0 00-3.075 7.425 1 1 0 01-1 1zM22.219 17.663a6.698 6.698 0 01-2.38-5.125V9.75c0-3.519-2.613-6.432-6-6.92V1.75a1 1 0 10-2 0v1.08c-3.386.488-6 3.401-6 6.92v2.788a6.706 6.706 0 01-2.387 5.133 1.752 1.752 0 001.138 3.08h16.5c.965 0 1.75-.786 1.75-1.751 0-.512-.223-.996-.621-1.337zM12.84 24.607a3.756 3.756 0 003.674-3H9.166a3.756 3.756 0 003.674 3z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"icon-bell_svg__clip0_4472_6556"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.998 .75)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    